import { InvitationFiltersFormValues } from "./Invites/InvitationFiltersForm/types";

export const determinateInvitationFiltersCount = (
    searchParameters: InvitationFiltersFormValues
  ): number => {
    let count = 0;
    if (searchParameters?.createDate?.startDate && searchParameters?.createDate?.endDate) count++;
    if (searchParameters.fullName) count++;
    if (searchParameters.statuses?.length) count++;
    if (searchParameters.email) count++;
    return count;
  };